module.exports = __webpack_public_path__ + "static/media/men-woman@2x.0e4e4ccb.png";